import { Download, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { API, WHATSAPP_URL } from "../data/content";

export default function ProfileCTA() {
  return (
    <section id="profile" data-testid="profile-section" className="noise relative bg-[#0A0A0A] py-28 md:py-36 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(ellipse 50% 60% at 50% 50%, rgba(212,175,55,0.07), transparent 70%)" }} />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <Reveal className="lg:col-span-7">
            <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-4">For Corporate &amp; Event Planners</p>
            <h2 className="font-serif-e text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#F9F9F6] leading-tight">
              Take our company profile with you.
            </h2>
            <p className="text-[#F9F9F6]/60 text-base md:text-lg leading-relaxed mt-6 max-w-xl">
              Our full profile — services, values, capability and packaging philosophy — in one elegant PDF. Perfect for sharing with procurement teams, event organisers and decision makers.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="border border-[#D4AF37]/40 bg-[#1A1A1A] p-8 md:p-10">
              <p className="font-serif-e text-3xl text-[#F9F9F6]">NOVAPHI</p>
              <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mt-1">Company Profile — PDF</p>
              <div className="h-px bg-[#F9F9F6]/10 my-6" />
              <ul className="space-y-2 text-sm text-[#F9F9F6]/60">
                <li>— Services &amp; speciality offerings</li>
                <li>— Corporate &amp; institutional capability</li>
                <li>— Packaging philosophy &amp; values</li>
                <li>— Team, story &amp; contact details</li>
              </ul>
              <a href={`${API}/company-profile.pdf`} data-testid="download-profile-btn"
                 className="mt-8 flex items-center justify-center gap-3 rounded-full bg-[#D4AF37] text-[#0A0A0A] px-8 py-4 text-xs uppercase tracking-[0.2em] font-semibold hover:bg-[#F9F9F6] transition-colors">
                <Download size={15} strokeWidth={1.5} /> Download Profile
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="profile-whatsapp-btn"
                 className="mt-3 flex items-center justify-center gap-3 rounded-full border border-[#F9F9F6]/25 text-[#F9F9F6] px-8 py-4 text-xs uppercase tracking-[0.2em] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
                <MessageCircle size={15} strokeWidth={1.5} /> Chat to Us First
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
